import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';
import { ticketingDashboardEventDatesKeys } from './event-dates/keys';
import { ticketingDashboardEventsKeys } from './events/keys';
import { ticketingDashboardStatKeys } from './stats/keys';

const ticketingDashboardKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'ticketing_dashboard'] as const;
  return createQueryKey({
    all: [...key] as const,
    stats: ticketingDashboardStatKeys([...key] as const),
    eventDates: ticketingDashboardEventDatesKeys([...key] as const),
    events: ticketingDashboardEventsKeys([...key] as const),
  });
};

export { ticketingDashboardKeys };
